import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

class HelideckTieTestItem extends Form {
	state = {
		data: {
			netNumber: '',
			testPressure: '',
			result: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		netNumber: Joi.string().allow('').required().label('Net Number'),
		testPressure: Joi.number().min(0).required().label('Test Pressure'),
		result: Joi.string().required().label('Result'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({
			data: {
				netNumber: '',
				testPressure: '',
				result: '',
			},
		});
	};
	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'netNumber',
							placeholder: 'Enter Net Number',
							label: 'Net Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'testPressure',
							placeholder: 'Enter Test Pressure',
							label: 'Test Pressure',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'result',
							placeholder: 'Enter result',
							label: 'result',
						})}
					</div>
				</div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default HelideckTieTestItem;
